import React from "react";
import {Link} from "gatsby";
import categories from "../../../data/categories";
import Title from "../Title/Title";
import Tag from "../Tag/Tag";

class PostListing extends React.Component {
  getPostList() {
    const postList = [];
    // eslint-disable-next-line react/destructuring-assignment
    this.props.postEdges.forEach(postEdge => {
      // let isCategory;
      // isCategory = true;
      // if(postEdge.category === undefined) {
      //   isCategory = false;
      // }
      postList.push({
        // path: postEdge.node.fields.slug,
        tags: postEdge.node.frontmatter.tags,
        cover: postEdge.node.frontmatter.cover,
        author: postEdge.node.frontmatter.author,
        title: postEdge.node.frontmatter.title,
        slug: postEdge.node.frontmatter.slug,
        date: postEdge.node.frontmatter.date,
        category: {
          slug: postEdge.node.frontmatter.category, title: categories[postEdge.node.frontmatter.category].title,
          seoTitle: categories[postEdge.node.frontmatter.category].seoTitle
        },
        
        excerpt: postEdge.node.excerpt,
        // timeToRead: postEdge.node.timeToRead
      });
    });
    return postList;
  }

  render() {
    const posts = this.getPostList();
    const {type} = this.props;
    return (
      <>
        {
          posts.map(post => (
            <div className="post-z-c1" key={post.slug}>
              <div className="post-z-c1-header">
                <div className="post-z-c1-author">
                  <div className="post-z-c1-author-col-1">
                    <div className="post-z-c1-avatar">
                      <img src="https://scontent.fdad2-1.fna.fbcdn.net/v/t1.0-1/cp0/p80x80/68890229_1089867301403037_2600093563714797568_o.jpg?_nc_cat=111&_nc_sid=7206a8&_nc_ohc=cgfU8VxDdvAAX-FY7tt&_nc_ht=scontent.fdad2-1.fna&oh=8bc8ab389605b207524d2c48f9c8a9dc&oe=5ED157A1" alt="" />
                    </div>
                  </div>
                  <div className="post-z-c1-author-col-2">
                    <div className="post-z-c1-name">
                      {post.author}
                    </div>
                    <div className="post-z-c1-category-date">

                      <div className="post-z-c1-date">
                        {/* Apr 5 2020 */}
                        {post.date}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Title post={post} type={type} />
              <div className="post-z-c1-body">
                <p>
                  {post.excerpt}
                  <Link
                    to={`${post.slug}/`}
                    key={post.id}
                  >
                    (Xem thêm)
                  </Link>
                </p>
              </div>
              <Tag post={post} />
            </div>
          ))
        }
      </>
    );
  }
}

export default PostListing;
